/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type UserCustomersTable_CustomerFragment = { __typename: 'PartialCustomer', id: string, name: string, displayCount: number, waveSubscription?: { __typename: 'WaveSubscription', id: string, name: string, usage: { __typename: 'SubscriptionUsage', max?: number | null, current: number } } | null, waveSubscriptions?: Array<{ __typename: 'WaveSubscription', id: string, name: string, validUntil: any, userGivenName?: string | null, status: Types.WaveSubscriptionStatus, usage: { __typename: 'SubscriptionUsage', max?: number | null, current: number } }> | null };

export const UserCustomersTable_CustomerFragmentDoc = gql`
    fragment UserCustomersTable_customer on PartialCustomer {
  id
  name
  displayCount
  waveSubscription {
    id
    name
    usage {
      max
      current
    }
  }
  waveSubscriptions {
    id
    name
    validUntil
    userGivenName
    usage {
      max
      current
    }
    status
  }
}
    `;